import React, { useState } from 'react';
import { Button, Input, Card, CardBody, Spinner } from '@nextui-org/react';
import { supabase } from 'common/src/supabase';

interface Payment {
  id: string;
  date_created: string;
  date_approved: string;
  status: string;
  transaction_amount: number;
  // Add more fields as needed
}

const MercadoPagoPayments: React.FC = () => {
  const [payments, setPayments] = useState<Payment[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [offset, setOffset] = useState('0');
  const [limit, setLimit] = useState('10');

  const fetchPayments = async () => {
    setIsLoading(true);
    setError(null);

    try {
      const { data, error } = await supabase.functions.invoke('getMercadoPagoPayments', {
          body: JSON.stringify({
            offset: parseInt(offset),
            limit: parseInt(limit),
          }),
        });
      if (error) throw error;
      setPayments(data.results);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'An error occurred while fetching payments');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Card>
      <CardBody>
        <h2 className="text-2xl font-bold mb-4">Mercado Pago Payments</h2>
        <div className="flex space-x-4 mb-4">
          <Input
            type="number"
            label="Offset"
            value={offset}
            onChange={(e) => setOffset(e.target.value)}
          />
          <Input
            type="number"
            label="Limit"
            value={limit}
            onChange={(e) => setLimit(e.target.value)}
          />
          <Button onClick={fetchPayments} disabled={isLoading}>
            {isLoading ? <Spinner size="sm" /> : 'Fetch Payments'}
          </Button>
        </div>
        {error && <p className="text-red-500 mb-4">{error}</p>}
        {payments.length > 0 ? (
          <ul className="space-y-4">
            {payments.map((payment) => (
              <li key={payment.id} className="border p-4 rounded">
                <p>ID: {payment.id}</p>
                <p>Date Created: {new Date(payment.date_created).toLocaleString()}</p>
                <p>
                  Date Approved:{' '}
                  {payment.date_approved ? new Date(payment.date_approved).toLocaleString() : 'N/A'}
                </p>
                <p>Status: {payment.status}</p>
                <p>Amount: ${payment.transaction_amount.toFixed(2)}</p>
              </li>
            ))}
          </ul>
        ) : (
          <p>No payments found.</p>
        )}
      </CardBody>
    </Card>
  );
};

export default MercadoPagoPayments;
